/**
 * Project: academy-v2
 * File: CheckIcon
 * Author: wanpeninsula
 * Author URI: https://www.pennycodes.dev
 * Created: 03/01/2024 at 1:31 pm
 *
 * Copyright (c) 2024 academy-v2. All rights reserved.
 */
import React from "react";
const CheckIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={9}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M4.097 7.036 10.664.24c.155-.16.339-.241.552-.241a.74.74 0 0 1 .552.24c.154.16.232.351.232.572 0 .221-.078.411-.232.571L4.64 8.76a.731.731 0 0 1-1.085 0L.223 5.312A.762.762 0 0 1 0 4.74a.826.826 0 0 1 .243-.57c.155-.161.339-.241.552-.241a.74.74 0 0 1 .552.24l2.75 2.867Z"
    />
  </svg>
);

export default CheckIcon;
